import React from 'react';
import DsModal from '../../DsModal';
import MemberListModalSkeleton from './MemberListModalSkeleton';

export default function MemberListModalLayout({
  onClose,
  dialogClassName = 'member-modal__dialog',
  dialogProps = {},
  titleClassName = 'member-modal__title',
  titleIconClassName = 'fa-solid fa-people-group',
  titleText = 'メンバーリスト',
  headerActions = null,
  bodyClassName = 'member-modal__body',
  loading = false,
  loadingLabel = '読み込み中...',
  loadingShowPartScopeTabs = true,
  loadingShowArtistTrailing = true,
  children,
  profileNode = null,
  profilePlacement = 'outside',
}) {
  const titleNode = (
    <span className={titleClassName}>
      <i className={titleIconClassName} aria-hidden="true" /> {titleText}
    </span>
  );

  return (
    <>
      <DsModal
        open
        onClose={onClose}
        title={titleNode}
        headerActions={headerActions}
        className={dialogClassName}
        {...dialogProps}
      >
        {loading ? (
          <div className={`${bodyClassName} member-modal__loading-host`}>
            <MemberListModalSkeleton
              label={loadingLabel}
              showPartScopeTabs={loadingShowPartScopeTabs}
              showArtistTrailing={loadingShowArtistTrailing}
            />
          </div>
        ) : (
          <div className={bodyClassName}>{children}</div>
        )}
        {profilePlacement === 'inside' ? profileNode : null}
      </DsModal>
      {profilePlacement !== 'inside' ? profileNode : null}
    </>
  );
}
